export function relativeTime(value,now=Date.now()){
 const stamp=Date.parse(value);if(!Number.isFinite(stamp))return 'Test tarihi yok';
 const seconds=Math.floor((now-stamp)/1000);if(seconds<0)return 'Sunucu saati ileride';
 if(seconds<60)return 'Az önce';if(seconds<3600)return Math.floor(seconds/60)+' dk önce';
 if(seconds<86400)return Math.floor(seconds/3600)+' sa önce';return Math.floor(seconds/86400)+' gün önce';
}
export function latencyView(ms){
 if(typeof ms!=='number'||!Number.isFinite(ms)||ms<0)return {label:'Süre ölçümü yok',tone:'off',width:0};
 return {label:Math.round(ms).toLocaleString('tr-TR')+' ms',tone:ms<1000?'connected':ms<=3000?'ready':'error',width:Math.min(100,Math.max(3,ms/100))};
}
export function modelState(model,test,fresh,clock){
 if(!fresh)return {tone:'off',label:'Veri güncel değil'};
 const route=model.gateway||{};
 // PMC_DIAGNOSIS_UI_V1 — color is presentation only; original FAIL remains in evidence.
 if(test?.freshness_state==='FRESH'&&(test.failure_code==='HTTP_429'||test.failure_code==='RATE_LIMITED'))return {tone:'ready',label:'Hız / kota sınırı'};
 if(route.circuit_state==='OPEN'&&Date.parse(route.open_until)>Date.parse(clock))return {tone:'error',label:'Rota hata beklemesinde'};
 if(test?.freshness_state==='FRESH'&&test.status==='FAIL')return {tone:'error',label:'Test başarısız'};
 if(test?.freshness_state==='FRESH'&&test.status==='DEGRADED')return {tone:'ready',label:'Test uyarısı'};
 if(!model.tenant_enabled)return {tone:'ready',label:'Etkinleştirme bekliyor'};
 if(model.connection_status!=='CONNECTED')return {tone:'ready',label:'Bağlantı bekliyor'};
 if(!test)return {tone:'off',label:'Test kaydı yok'};
 if(test.freshness_state!=='FRESH')return {tone:'ready',label:'Yeniden test gerekli'};
 // Passing CHAT does not prove all PM, role and Memory selection gates.
 return {tone:'connected',label:'Test başarılı',note:'Kullanım izni açık; rota koşulları ayrıca değerlendirilir.'};
}
